import { Injectable } from '@angular/core';

import { TargetingResultFactory } from '../../../factories/targeting-result.factory';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';
import { ContactsPublicApi } from '../../../../../api/targeting/contacts-public.api';
import { OutletsPublicApi } from '../../../../../api/targeting/outlets-public.api';
import { TargetingListsApiService } from '../../../../../api/targeting/targeting-lists.api.service';
import { TargetingSearchesApiService } from '../../../../../api/targeting/targeting-searches.api.service';
import { JournodexRegionsService } from '../../../../../Common/Journodex/services/journodex-regions.service';
import { JournodexSubjectsService } from '../../../../../Common/Journodex/services/journodex-subjects.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { userPermissionsEnum } from '../../../../../Core/Users/enums/user-permissions.enum';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { MonitorConfigService } from '../../../../../Common/MonitorShared/services/monitor-config.service';
import { MediaTypeModel } from '../../../../../Monitor/Shared/models/media-type.model';
import { JournodexEnumsService } from '../../../../Core/services/journodex-enums.service';
import { DiscoverRoutingService } from '../../../../DiscoverRouter/services/discover-routing.service';
import { SourcePickerService } from '../../../services/source-picker-service';
import { DistributionApi } from '../../../../../api/distributions/distribution.api';
import { TargetingMiscApi } from '../../../../../api/targeting/targeting-misc.api';
import { TargetingSearchesService } from '../../../services/targeting-searches.service';


@Injectable()
export class StreamSourcePickerService extends SourcePickerService {

    public userHasMonitoring: boolean;
    private keywordStreamMode: boolean;

    private readonly influencerStreamDefaultMediaTypes = [
        MediaTypeEnum.ONLINE_NEWS,
        MediaTypeEnum.BLOGS,
        MediaTypeEnum.TWITTER,
        MediaTypeEnum.INSTAGRAM
    ];

    constructor(
        protected discoverRoutingService: DiscoverRoutingService,
        protected targetingSearchesApiService: TargetingSearchesApiService,
        protected targetingSearchesService: TargetingSearchesService,
        protected targetingListsApiService: TargetingListsApiService,
        protected subjectsService: JournodexSubjectsService,
        protected journodexEnumsService: JournodexEnumsService,
        protected journodexRegionService: JournodexRegionsService,
        protected localizationService: LocalizationService,
        protected contactsPublicApi: ContactsPublicApi,
        protected outletsPublicApi: OutletsPublicApi,
        protected currentUserService: CurrentUserStateService,
        protected monitorConfigService: MonitorConfigService,
        protected targetingResultFactory: TargetingResultFactory,
        protected currentUserStateService: CurrentUserStateService,
        protected distributionApi: DistributionApi,
        protected targetingMiscApi: TargetingMiscApi
    ) {
        super(discoverRoutingService,
            targetingSearchesApiService,
            targetingSearchesService,
            targetingListsApiService,
            subjectsService,
            journodexEnumsService,
            journodexRegionService,
            localizationService,
            contactsPublicApi,
            outletsPublicApi,
            targetingResultFactory,
            currentUserStateService,
            distributionApi,
            targetingMiscApi
        );

        this.subscriptions.push(
            this.currentUserService.getPermissions().subscribe(permissions => {
                this.userHasMonitoring = !!permissions?.find(x => x === userPermissionsEnum.advancedMonitoring);
                this.prepareStreamContentFilter();
            })
        );
    }

    prepareStreamContentFilter(): void {
        // NEP-12776 - hide tiktok as not supported by b/e yet
        const allMediaTypes = MediaTypeModel.getAllMediaTypesExceptTikTok();

        if (this.userHasMonitoring) {
            this.monitorConfigService.getAvailableMediaTypes().subscribe(
                mediaTypes => {
                    this.streamContentFilter.options = [];
                    allMediaTypes.forEach(item => {
                        if (mediaTypes.indexOf(item.id) !== -1){
                            item.isProvisioned = true;
                        } else {
                            item.isProvisioned = false;
                        }

                        this.streamContentFilter.options.push({
                            label: item.name,
                            value: item
                        });
                    });
                }
            );
        } else {
            allMediaTypes.forEach(item => {
                if (this.influencerStreamDefaultMediaTypes.find(type => type === item.id)) {
                    item.isProvisioned = true;
                } else {
                    item.isProvisioned = false;
                }

                this.streamContentFilter.options.push({
                    label: item.name,
                    value: item
                });
            });
        }
    }

    setStreamContentFilter(mentionMediaTypes: string[]): void {
        if (!mentionMediaTypes) {
            return;
        }
        this.streamContentFilter.setValue(this.streamContentFilter.options
            .filter(item => mentionMediaTypes.indexOf(item.value.id) !== -1)
            .map(item => item.value));
    }

    changeToKeywordStreamMode(): void {
        this.keywordStreamMode = true;
        this.setFilters([this.streamContentFilter]);
    }

    leaveKeywordStreamMode(): void {
        if (this.keywordStreamMode) {
            this.keywordStreamMode = false;
            this.setFilters(this.allFilters);
        }
    }
}

